import script from "./UploadBudgetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadBudgetPage.vue?vue&type=script&setup=true&lang=js"

import "./UploadBudgetPage.vue?vue&type=style&index=0&id=4ff3bbd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff3bbd0"]])

export default __exports__